<template>
  <div>
    <div class="z-20 fixed inset-0 overflow-hidden">
      <div class="absolute inset-0 overflow-hidden">
        <section class="absolute inset-y-0 right-0 pl-10 max-w-full flex">
          <transition
            enter-active-class="transform transition ease-in-out duration-500 sm:duration-700"
            leave-active-class="transform transition ease-in-out duration-500 sm:duration-700"
            enter-class="translate-x-full"
            enter-to-class="translate-x-0"
            leave-class="translate-x-0"
            leave-to-class="translate-x-full"
          >
            <div v-if="showTransition" class="w-screen max-w-2xl">
              <div id="right-slide-panel" class="h-full flex flex-col bg-white shadow-xl overflow-y-scroll">
                <div class="py-6 px-4 bg-indigo-700 sm:px-6 mb-6">
                  <div class="flex items-center justify-between">
                    <h2 id="slide-over-heading" class="text-lg font-medium text-white">
                      {{ title }}
                    </h2>
                    <div class="ml-3 h-7 flex items-center">
                      <button
                        @click="closePanel"
                        class="bg-indigo-700 rounded-md text-indigo-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                      >
                        <span class="sr-only">Close panel</span>
                        <svg
                          class="h-6 w-6"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M6 18L18 6M6 6l12 12"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                  <div class="mt-1">
                    <p class="text-sm text-indigo-300">
                      {{ description }}
                    </p>
                  </div>
                </div>
                <div class="relative flex-1 px-4 sm:px-6">
                  <!-- Replace with your content -->
                  <slot></slot>
                  <!-- /End replace -->
                </div>
                <div v-if="!hideActions" class="flex-shrink-0 px-4 py-4 space-x-4 flex justify-end">
                  <span class="inline-flex rounded-md shadow-sm">
                    <TButton label="Close" color="white" @click="closePanel" />
                  </span>
                  <span class="inline-flex rounded-md shadow-sm">
                    <TButton v-if="action" :label="action" color="indigo" @click="handleAction">
                      <LocalLoadingSpinner />
                    </TButton>
                  </span>
                </div>
              </div>
            </div>
          </transition>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['show', 'title', 'description', 'action', 'hideActions'],
  components: {},
  mounted() {
    this.showTransition = true;
    document.addEventListener('keydown', e => {
      if (this.showTransition && e.keyCode == 27) {
        this.closePanel();
      }
    });
  },
  data() {
    return {
      showTransition: false,
    };
  },
  methods: {
    closePanel() {
      const self = this;

      self.showTransition = false;
      setTimeout(function () {
        self.$emit('handleClosePanel');
      }, 500);
    },
    handleAction() {
      const self = this;
      self.$emit('handleAction');
    },
  },
};
</script>
